import { render, staticRenderFns } from "./IM_2_2.vue?vue&type=template&id=14a0a1d6&scoped=true&"
import script from "./IM_2_2.vue?vue&type=script&lang=js&"
export * from "./IM_2_2.vue?vue&type=script&lang=js&"
import style0 from "./IM_2_2.vue?vue&type=style&index=0&id=14a0a1d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a0a1d6",
  null
  
)

export default component.exports